/**
 * @file axios 请求封装
 * @version 1.0.0
 * @author pankzou
 * @date 2021-09-18
 * @lastModified
 * @lastModifiedDate
 */
import Axios from 'axios';
import Qs from 'qs';
import router from '../router/index.js'

// axios 默认配置
Axios.defaults.baseURL = process.env.VUE_APP_API_URL;// 请求baseUrl地址配置
Axios.defaults.timeout = 10000; //响应时间

// 添加请求拦截器
Axios.interceptors.request.use(
    config => {
        // 请求加载提示
        // TODO

        // 如果为post请求，在发送请求之前序列化参数
        if (config.method === 'post') {
            let contentType = config.headers['Content-Type'];

            if (contentType.indexOf('application/x-www-form-urlencoded') !== -1) {
                config.data = Qs.stringify(config.data);
            } else if (contentType.indexOf('application/json') !== -1) {
                config.data = JSON.stringify(config.data);
            }
        }

        /*
         * 如果接口需要验证用户的身份，在此将token添加到http header中。
         * 判断是否存在token，如果存在的话，则每个http header都加上token。
         * 如果不存在，有两种情况：
         *  1.用户未登录。
         *  2.接口不需要登录。
         * 在情况2下，不能统一将用户拦截至登录页面。应根据接口定义的状态码判断用户是否登录。
         */
        let token = window.localStorage.getItem("token");
        if (token) {
            config.headers['token'] = token;
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 添加响应拦截器
Axios.interceptors.response.use(
    // 服务器状态码：以2开头的的情况
    response => {
        // 请求成功,关闭加载提示
        // TODO

        // 如果返回的服务器状态码为200，说明接口请求成功，可以正常拿到数据；否则的话抛出错误
        if (response.status === 200) {
            // 接口的状态码：
            if (response.data.code === 401) {// 如果返回的接口的状态码为401，说明未登录或登录过期，拦截至登录页面
                router.push({
                    name: 'login',
                    query: {
                        redirect: redirect
                    }
                })

            }

            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }

        // return response;
    },
    // 服务器状态码：不以2开头的的情况
    error => {
        // 请求失败,关闭加载提示,并显示网络连接错误
        // TODO

        // 异常处理
        if (error.response) {
            // 发送请求后，服务端返回的响应码不是 2xx
            console.error('Response Error', error);
        } else if (error.request) {
            // 发送请求但是没有响应返回
            console.error('Request Error', error);
        } else {
            // 其他错误
            console.error('Error', error.message);
        }

        return Promise.reject(error);
    }
);

/*
 * 返回一个Promise（发送get请求）
 * @param {string} url - 请求地址
 * @param {object} params - 请求头数据
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        Axios.get(url, {
            params: params
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
}

/*
 * 返回一个Promise（发送post请求）
 * @param {string} url - 请求地址
 * @param {object} data - 请求体数据
 * @param {number} contentType - contentType 类型：1.application/x-www-form-urlencoded；2.application/json。
 */
export function post(url, data, contentType = 1) {
    return new Promise((resolve, reject) => {
        Axios.post(url, data, {
            headers: {
                'Content-Type': contentType === 1 ? 'application/x-www-form-urlencoded' : 'application/json'
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

export function postQuery(url, data, headers) {
    return new Promise((resolve, reject) => {
        Axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json',
                ...headers
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}

/*
 * 返回一个Promise（发送post请求）
 * @param {string} url - 请求地址
 * @param {object} params - 请求头数据
 * @param {object} data - 请求体数据
 * @param {number} contentType - contentType 类型：1.application/x-www-form-urlencoded；2.application/json。
 */
export function postParams(url, params, data, contentType = 1) {
    return new Promise((resolve, reject) => {
        Axios({
            method: 'POST',
            url: url,
            params: params,
            data: data,
            headers: {
                'Content-Type': contentType === 1 ? 'application/x-www-form-urlencoded' : 'application/json'
            }
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}


/*
 * 返回一个Promise（文件上传）
 * @param {object} data - 请求体数据
 */
export function upload(url, data) {
    let instance = Axios.create({
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });

    return new Promise((resolve, reject) => {
        instance({
            method: 'POST',
            url: url,
            data: data,
        }).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    })
}